import { CommonModule } from '@angular/common';
import { Component, computed, inject, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import {
  MAT_DATE_LOCALE,
  provideNativeDateAdapter,
} from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  DeviceService,
  NMultiselectComponent,
} from '@nomoh-monorepo/shared-common-ui';
import { ButtonModule } from 'primeng/button';
import { DatePickerModule } from 'primeng/datepicker';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectModule } from 'primeng/select';
import { TranslateModule } from '@ngx-translate/core';

// TODO: Ajustar imports
import {
  AgendaService,
  NichoTermosService,
} from '@nomoh-monorepo/data-access-bardo-administrador';
import { AgendaFiltroService } from './services/agenda-filtro.service';
// import { ProfissionalDataService } from '@nomoh-monorepo/data-access-bardo-administrador-profissional';

@Component({
  selector: 'lib-agenda-filtro',
  standalone: true,
  imports: [
    SelectModule,
    FormsModule,
    CommonModule,
    MultiSelectModule,
    NMultiselectComponent,
    DatePickerModule,
    MatDatepickerModule,
    MatCardModule,
    ButtonModule,
    TranslateModule,
  ],
  providers: [
    provideNativeDateAdapter(),
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
  ],
  templateUrl: './agenda-filtro.component.html',
  styleUrl: './agenda-filtro.component.scss',
})
export class AgendaFiltroComponent {
  agendaFiltroService = inject(AgendaFiltroService);
  AgendaService = inject(AgendaService);
  deviceService = inject(DeviceService);
  private nichoTermosService = inject(NichoTermosService);

  $nicho = this.nichoTermosService.$nicho;

  /** Lista plana de serviços (para lib-n-multiselect que não suporta grupos) */
  servicosFlat = computed(() =>
    this.agendaFiltroService
      .grupoServicos()
      .flatMap((grupo) => grupo.items ?? [])
  );
  // profissionalDataService = inject(ProfissionalDataService); // TODO

  selected = model<Date | null>(null);

  // Arrays locais para two-way binding
  servicosSelecionados: string[] = [];
  profissionaisSelecionados: string[] = [];

  alternarFiltro(filtroNome: string): void {
    this.agendaFiltroService.alternarFiltro(filtroNome);
  }

  onServicosChange(): void {
    this.agendaFiltroService.servicosSelecionados.set(
      this.servicosSelecionados
    );
    this.agendaFiltroService.filtrarAgendamento();
  }

  onProfissionaisChange(): void {
    this.agendaFiltroService.profissionaisSelecionados.set(
      this.profissionaisSelecionados
    );
    this.agendaFiltroService.filtrarAgendamento();
  }

  limparFiltros(): void {
    this.servicosSelecionados = [];
    this.profissionaisSelecionados = [];
    this.agendaFiltroService.filtrosAtivos.set([]);
    this.agendaFiltroService.servicosSelecionados.set([]);
    this.agendaFiltroService.profissionaisSelecionados.set([]);
    this.agendaFiltroService.filtrarAgendamento();
  }

  constructor() {
    // TODO: Descomentar quando services estiverem disponíveis
    // effect(() => {
    //   const profissionais = this.profissionalDataService.$profissionais();
    //   if (profissionais) {
    //     this.agendaFiltroService.profissionais = profissionais;
    //   }
    // });
  }
}
